import React, { Component, cloneElement, Children, Fragment } from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import LoadingLine from '../LoadingLine';

export default class Table extends Component {
  generateItem = item => {
    const { children } = this.props;

    return Children.map(children, c => cloneElement(c, item));
  };

  render() {
    const {
      items,
      maxItems,
      rowOnClick,
      loading,
      gridLayout,
      firstTitleColumn,
      lastTotalColumn,
      rowClassName,
      headerClassName,
      children,
      rowKey
    } = this.props;

    const generateKey = item =>
      typeof rowKey === 'function' ? rowKey(item) : item[rowKey];

    const headers = Children.map(
      children,
      ({ props: { label, columnAlign, columnSize } }) => ({
        label,
        columnSize,
        columnAlign
      })
    );

    return (
      <Fragment>
        <TableHeader
          headers={headers}
          gridLayout={gridLayout}
          className={headerClassName}
        />

        {loading && <LoadingLine style={{ backgroundColor: 'white' }} />}

        {!loading &&
          items.slice(0, maxItems).map(item => {
            const generatedKey = generateKey(item);

            return (
              <TableRow
                rowOnClick={rowOnClick}
                item={item}
                rowKey={generatedKey}
                key={generatedKey}
                gridLayout={gridLayout}
                firstTitleColumn={firstTitleColumn}
                lastTotalColumn={lastTotalColumn}
                className={rowClassName}
              >
                {this.generateItem(item)}
              </TableRow>
            );
          })}
      </Fragment>
    );
  }
}

Table.defaultProps = {
  maxItems: undefined,
  rowOnClick: null,
  loading: false,
  gridLayout: false,
  firstTitleColumn: false,
  lastTotalColumn: false
};

Table.propTypes = {
  items: PropTypes.array,
  children: PropTypes.array,
  maxItems: PropTypes.number,
  rowOnClick: PropTypes.func,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  loading: PropTypes.bool,
  firstTitleColumn: PropTypes.bool,
  lastTotalColumn: PropTypes.bool,
  gridLayout: PropTypes.bool,
  rowClassName: PropTypes.string,
  headerClassName: PropTypes.string
};
